import {SleepAsync} from "js-vextensions";
import {FindReact} from "react-vextensions";

// Node
// ==========

//(()=> {
HTMLElement.prototype._AddGetter_Inline = function R() { return FindReact(this); };
//})();

// Promise
// ==========

declare global { interface Promise<T> { WaitXOr(waitTimeMS: number, resultIfTooSlow: T): Promise<T>; } }
Promise.prototype.WaitXOr = function<T>(this: Promise<T>, waitTimeMS: number, resultIfTooSlow: T): Promise<T> {
	return WaitXFor(waitTimeMS, resultIfTooSlow, this);
}
export async function WaitXFor<T>(waitTimeMS: number, resultIfTooSlow: T, promise: Promise<T>): Promise<T> {
	return Promise.race([
		promise,
		SleepAsync(waitTimeMS).then(()=>resultIfTooSlow),
	]);
}